declare var process: any;

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import { Topbar } from '../../components';

interface Props {
  children: any;
  isLoaded: boolean;
}

const AppWrapper = ({ children, isLoaded = false }: Props) => {
  if (!isLoaded) {
    return <Helmet titleTemplate="Loading..." />;
  }
  return (
    <div className="app">
      <Helmet titleTemplate={`%s | ${process.env.APP_NAME}`} />
      <Topbar />
      <div className="app-content">{children}</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoaded: state.app.isLoaded,
});

export default withRouter(connect(mapStateToProps)(AppWrapper));
